"use strict";

export const debug_log = function(data) {
    console.log(data)
}
export const debug_log_msg = function(msg, data) {
    console.log(msg + ":", data)
}
